import validate from "/workspace/node_modules/nuxt/dist/pages/runtime/validate.js";
import _000_45customer_45enquete_45redirect_45global from "/workspace/src/middleware/000-customer-enquete-redirect.global.ts";
import _001_45prevent_45illegal_45page_45transition_45global from "/workspace/src/middleware/001-prevent-illegal-page-transition.global.ts";
import _002_45session_45check_45global from "/workspace/src/middleware/002-session-check.global.ts";
import _003_45access_45log_45global from "/workspace/src/middleware/003-access-log.global.ts";
import manifest_45route_45rule from "/workspace/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _000_45customer_45enquete_45redirect_45global,
  _001_45prevent_45illegal_45page_45transition_45global,
  _002_45session_45check_45global,
  _003_45access_45log_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/workspace/src/middleware/auth.ts"),
  "buy-after-enquete-check": () => import("/workspace/src/middleware/buy-after-enquete-check.ts"),
  "check-customer-enquete-status": () => import("/workspace/src/middleware/check-customer-enquete-status.ts"),
  "is-valid-postal-codes": () => import("/workspace/src/middleware/is-valid-postal-codes.ts"),
  "redirect-if-not-special-rank": () => import("/workspace/src/middleware/redirect-if-not-special-rank.ts"),
  "show-password-reset-form": () => import("/workspace/src/middleware/show-password-reset-form.ts"),
  "validate-cart-set-query": () => import("/workspace/src/middleware/validate-cart-set-query.ts"),
  "validate-order-key": () => import("/workspace/src/middleware/validate-order-key.ts"),
  "validate-regular-id-param": () => import("/workspace/src/middleware/validate-regular-id-param.ts"),
  "withdrawal-complete": () => import("/workspace/src/middleware/withdrawal-complete.ts")
}